/**
 * Font Awesome 6 list
 */

import { signal } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { createInjectionToken } from 'ngxtension/create-injection-token';

export type AuiIconWeight = 'fal' | 'fas' | 'far' | 'fa-brands';

export type AuiIconSize = 'xs' | 'sm' | 'lg' | '2x' | '3x' | '4x' | '5x' | '6x' | '7x' | '8x' | '9x' | '10x';

export type AuiIcon = IconProp | 'hrapka' | 'ralba' | 'clipboard-clock' | 'flux-capacitor';

export const [injectAuiIconConfig, provideAuiIconConfig] = createInjectionToken(
    (defaultUseAssets = false) => {
        const useAssets = signal(defaultUseAssets);
        return { useAssets };
    },
    {
        isRoot: true,
    }
);
